import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import { ArticleSchema } from './Schema';

const DataForMarketingPage = () => {
  return (
    <div>
      <SEO
        title="Where to Buy Data for Marketing? - Lloyd James Data Consultancy"
        description="Learn where to buy data for marketing and how data analytics helps create segmented consumer lists. Discover Lloyd James' RESIDENT tool for targeted marketing strategies."
        keywords="buy data for marketing, data analytics marketing, consumer data lists, RESIDENT tool, Lloyd James, marketing data supplier"
        canonical="/data-for-marketing"
        type="article"
      />
      <ArticleSchema
        headline="Where to buy data for marketing?"
        description="Data analytics in marketing helps to create segmented consumer lists and insights which can be applied to create a successful database."
        author="Lloyd James Data Consultancy"
        datePublished="2024-01-01"
        image="/images/data-for-marketing-where-can-you-buy-it.webp"
        url="/data-for-marketing"
      />
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/data-for-marketing-where-can-you-buy-it.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              Where to buy data for marketing?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data analytics in marketing helps to create segmented consumer lists and insights which can be applied to create a successful database. This can be achieved through analyzing email metrics, B2B data and many more useful tools, all of which will be the core operations of a company's marketing strategy.
                  </p>

                  <p className="text-2xl font-semibold text-gray-900 mb-4">
                    The importance of data
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data driven marketing is an important tool for any business as its purpose is to form a strategy which will demonstrate what approaches work for a business. Through this, personalized marketing analytics can be created to correspond with the characteristics of a businesses' customers.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Lloyd James have helped several businesses to gain valuable insights from their existing customer data, and how this can be optimized to reach its full potential. <Link to="/evidence" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to read a few of our case studies.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    We are one of the UK's leading supplier of data services, which includes email marketing lists, consumer & business data lists and more. Contact one of our data experts today, we are almost certain we can make data work harder for you.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    How to buy data lists…
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Analytics in marketing can be purchased from a third-party supplier to increase brand awareness and receive data which can be directed to your specified audience. At Lloyd James, our market-leading product RESIDENT is the tool we implement to accurately harness the power of data to deliver a bespoke process for our customers.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Conducting an analysis is an essential process which helps consumers to achieve more from their market research. By understanding the wants and needs of your customers through data analytics, this will enhance the success of a marketing strategy.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    We focus on the needs of our customers to create long-term value by taking a consultative approach. Our analysis tools ensures that engagements are precisely targeted and significant to unlock the power of data for your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataForMarketingPage;